import { OnBoardingStep } from "./statusOverview";

export interface PostAccountSubscriptionResponse {
  onboardingStep: OnBoardingStep;
}

export interface GetAccountSubscriptionResponse {
  planName: string;
  planCode: string;
  subscriptionsCount: number;
  price: number;
  trial: boolean;
  couponCode?: string;
  maxCustomerCount?: number;
  currentCustomerCount?: number;
}

export enum PlanCodes {
  AiGrowthManager = "Manager",
  AiMarketingSpecialist = "Specialist",
  AiMarketingAssistant = "Assistant",
}

export interface GetSameSubscriptionResponse {
  subscriptions: {
    id: string;
    name: string;
    price: number;
    comingSoon: boolean;
    features: Array<{ name: string }>;
    sameSubscription: boolean;
  }[];
}
